import React from 'react';
import styled from 'styled-components';

import type { ICardButton } from './types';

export const CardButton = (props: ICardButton) => {
  const { text, isMobile, isBlue = false, url } = props;

  const href = `${url}?ref_content=main_page`;

  return (
    <StyledCardButtonWrapper $isMobile={isMobile} $isBlue={isBlue} href={href}>
      {text}
    </StyledCardButtonWrapper>
  );
};

const StyledCardButtonWrapper = styled.a<{
  $isMobile: boolean;
  $isBlue: boolean;
}>`
  background: ${({ $isBlue }) => ($isBlue ? '#e6f2ff' : '#fff')};
  color: #007aff;

  border: none;
  border-radius: 28px;

  font-size: 12px;
  line-height: 16px;

  text-decoration: none;

  margin: 2px 4px 2px 0;
  padding: ${({ $isMobile }) => ($isMobile ? `11px 8px 13px` : `3px 8px 5px`)};

  cursor: pointer;
`;
